import React from 'react';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import { countries } from 'react-flag-icon-css/lib/static/enums';
var InputCountryCode = function (props) { return (React.createElement(Select, { disabled: props.isDisabled, allowClear: true, showSearch: true, optionFilterProp: 'children', filterOption: function (input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, style: { width: '150px' }, value: props.value && props.value.toLowerCase(), onChange: props.onChange }, countries && countries.map(function (c) { return (React.createElement(Select.Option, { key: c.code, value: c.code }, c.name)); }))); };
export default InputCountryCode;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthleteCsvPage/InputCountryCode.tsx
// module id = 1320
// module chunks = 0